import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { Card, Alert } from 'antd'
import { formateDate} from '../../utils/dateUtil'
import { req_list_ars_reservationKeyCase } from '../../api'

class ReservationLogModal extends Component {

    // 基礎通用參數 //////////////////////////////////////////////

    static propTypes = {
        qualify: PropTypes.object.isRequired
    }

    state = {
        loading: false,
        items: []
    }

    // constructor(props) {
    //     super(props)
    // }

    UNSAFE_componentWillMount() {

    }

    componentDidMount() {
        this.api_list_reservationCase()
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_list_reservationCase = async () => {
        const { KeyId } = this.props.qualify
        const token = this.props.user.token
        this.setState({ loading: true })
        const result = await req_list_ars_reservationKeyCase(KeyId, token)
        this.setState({ loading: false })
        //console.log(result)
        if (result.data) {
            const items = result.data
            this.setState({ items })
        } else {
            this.setState({ items: [] })
        }
        console.log(result.data)
    }


    /////////////////////////////////////////////////////////// 



    /////////////////////////////
    render() {
        const { items } = this.state
        let data = items ? items.map((item) => <Alert
            message={formateDate(item.RecordCreateDateTime)}
            description={item.ReservationType === 'ONSITE' ? `${item.ClaimerName}申請現場領取`: `${item.ClaimerName}申請掛號郵寄`}
            type="info"
            showIcon
        />) : ''

        return (
            <Card>
                {data}
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(ReservationLogModal)